// extracted by mini-css-extract-plugin
export default {"badge":"neVqfYTm5avurtdMRQbv","content":"PcyG_hTZ4Ic7T8P6rM64","arrow":"NmIqxJjdD8An3dbtzcsY","closeButton":"QytKJBN1WwelgedpPgj5"};